import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/auth/AuthContext';
import { trackEvent } from '../lib/analytics';

const JoinSuccessPage = () => {
  const { refreshUserProfile, userProfile, isMember } = useAuth();
  const analyticsFiredRef = useRef(false);

  // Refresh user profile on mount to ensure we have latest membership status
  // This is a backup in case the refresh in JoinPage was too early
  useEffect(() => {
    refreshUserProfile();
  }, [refreshUserProfile]);

  useEffect(() => {
    if (analyticsFiredRef.current) return;
    analyticsFiredRef.current = true;
    trackEvent('membership_completed', { value: 209, currency: 'USD' });
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
      <div className="max-w-md w-full text-center p-8 bg-white shadow-lg rounded-lg">
        <svg
          className="w-16 h-16 mx-auto text-green-500 mb-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <h1 className="text-3xl font-serif text-[#232347] mb-2">
          Welcome!
        </h1>

        {/* Membership Status Badge */}
        {isMember && (
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-green-100 text-green-800 text-sm font-medium mb-4">
            <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            Active Member - 20% Discount on All Services
          </div>
        )}

        <p className="text-gray-600 mb-6">
          You are now a member. Thank you for joining the Healing Lotus Spa community. You can now enjoy all the exclusive benefits.
        </p>
        <div className="mt-8">
          <Link
            to="/"
            className="px-8 py-3 rounded-md text-white font-semibold bg-[#B2D8C5] hover:bg-[#88bfa3] transition-colors"
          >
            Go to Homepage
          </Link>
        </div>
        <div className="mt-4">
          <Link
            to="/profile" // Assuming a profile page exists
            className="text-sm text-[#3A5E63] hover:underline"
          >
            View My Profile
          </Link>
        </div>
      </div>
    </div>
  );
};

export default JoinSuccessPage;
